import React from 'react'
import './person-setting.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router-dom'
import Cookies from 'universal-cookie'
import { Toast } from 'antd-mobile'
@(withRouter as any)
export default class PersonSetting extends React.Component<any, any> {

    UNSAFE_componentWillMount() {
        setHeader({
            title: '个人设置',
            leftClick: this.leftClick,
        })
    }

    constructor(props: any) {
        super(props)
        this.state = {
            version: '1.8.1',
            cache: '',
            cookie: '',
        }
        window.getCache = (argument: any) => {
            this.setState({
                cache: argument
            })
        }
        if (window.WebViewBridge) {
            window.WebViewBridge.setCache()
        } else if (window.webkit) {
            window.webkit.messageHandlers.setCache.postMessage(null)
        }
    }

    componentDidMount() {
        const cookies = new Cookies()
        this.setState({
            version: cookies.get('app_version'),
            cookie: cookies.get('app_user_auth')
        })
    }

    leftClick() {
        //返回App
        if (window.WebViewBridge) {
            window.WebViewBridge.navBackMarket()
        } else if (window.webkit) {
            window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
    }

    /**
     * 清除缓存
     */
    clearCache = () => {
        Toast.show('已清除缓存' + this.state.cache)
        if (window.WebViewBridge) {
            window.WebViewBridge.clearCache()
        } else if (window.webkit) {
            window.webkit.messageHandlers.clearCache.postMessage(null)
        }
        this.setState({
            cache: ''
        })
    }

    /**
     * 隐私政策
     */
    privacyPolicy = () => {
        this.props.history.push(`/privacy`)
    }

    /**
     * 关于我们
     */
    aboutUs = () => {
        this.props.history.push(`/about`)
    }

    /**
     * 退出登录
     */
    logout() {
        if (window.WebViewBridge) {
            window.WebViewBridge.logout && window.WebViewBridge.logout()
        } else if (window.webkit) {
            window.webkit.messageHandlers.logout.postMessage(null)
        }
    }

    /**
     * 服务协议
     */
    serviceAgreement() {
        this.props.history.push(`/service-agreement`)
    }

    render() {
        return (
            <div className="setting">
                <div className="about-position" onClick={this.clearCache}>
                    <span>清除缓存</span>
                    <span>
                        <span className="right-text">{this.state.cache}</span>
                        <img className="img" src="/public/assets/img/ic_more.png" alt="" />
                    </span>
                </div>
                <div className="about-position" onClick={this.serviceAgreement.bind(this)}>
                    <span>服务协议</span>
                    <img className="img" src="/public/assets/img/ic_more.png" alt="" />
                </div>
                <div className="about-position" onClick={this.privacyPolicy}>
                    <span>隐私政策</span>
                    <img className="img" src="/public/assets/img/ic_more.png" alt="" />
                </div>
                <div className="about-position" onClick={this.aboutUs}>
                    <span>关于我们</span>
                    <span>
                        <span className="right-text">{this.state.version}</span>
                        <img className="img" src="/public/assets/img/ic_more.png" alt="" />
                    </span>
                </div>
                <div className={(this.state.cookie === '' || this.state.cookie === null) ? 'logout-invisible' : 'logout-visible'} onClick={this.logout}>退出登录</div>
            </div>
        )
    }
}